import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Apartments.css';    
import SlidingGallery from './SlidingGallery';

// Declare the hostawayCalendarWidget property on window
declare global {
  interface Window {
    hostawayCalendarWidget?: (config: any) => void;
  }
}

const Cairn: React.FC = () => {
  const images = [
    { url: `${process.env.PUBLIC_URL}/images/Cairn/hall_1.jpg`, alt: "Cairn hall 1" },
    { url: `${process.env.PUBLIC_URL}/images/Cairn/hall_2.jpg`, alt: "Cairn hall 2" },
    { url: `${process.env.PUBLIC_URL}/images/Cairn/bedroom.jpg`, alt: "Cairn bedroom" },
    { url: `${process.env.PUBLIC_URL}/images/Cairn/kitchen_1.jpg`, alt: "Cairn kitchen 1" },
    { url: `${process.env.PUBLIC_URL}/images/Cairn/kitchen_2.jpg`, alt: "Cairn kitchen 2" },
    { url: `${process.env.PUBLIC_URL}/images/Cairn/living_room.jpg`, alt: "Cairn living room" },
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    // Load the calendar script
    const script = document.createElement('script');
    script.src = 'https://d2q3n06xhbi0am.cloudfront.net/calendar.js';
    script.async = true;
    script.onload = () => {
      if (window.hostawayCalendarWidget) {
        window.hostawayCalendarWidget({
          baseUrl: 'https://119528_1.holidayfuture.com/',
          listingId: 419131,
          numberOfMonths: 2,
          openInNewTab: true,
          font: 'Open Sans',
          rounded: true,
          button: {
            action: 'checkout',
            text: 'Book now',
          },
          clearButtonText: 'Clear dates',
          color: {
            mainColor: '#666699',
            frameColor: '#000000',
            textColor: 'green',
          },
        });
      }
    };
    document.head.appendChild(script);
  }, []);

  return (
    <div className="location-container" style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
      <div className="location-content side-by-side-layout">
        <div className="image-section">
          <img 
            src={`${process.env.PUBLIC_URL}/images/Cairn/kitchen_1.jpg`} 
            alt="Cairn kitchen" 
            width="400"
            height="500" 
          />
        </div>

        <div className="content-section">
          <h3>Cairn Apartment</h3>
          <h3>Bright First-Floor One Bedroom Apartment with Scenic Views</h3>

          <p>
            Cairn is a charming and inviting <strong>one bedroom apartment</strong> located on the <strong>first floor</strong>, 
            offering a bright, sun-filled space and stunning views of the surrounding landscape.
          </p>

          <p>
            The bedroom includes both a <strong>double bed and a single bed</strong>, making it ideal for 
            <strong> single, twin, double, or triple occupancy</strong>. The <strong>bedroom and spacious kitchen/living area </strong> 
            both face toward the <strong>Pentland Hills</strong>, providing a beautiful backdrop and capturing the <strong>morning sun</strong> — 
            perfect for a peaceful start to your day.
          </p>

          <p>
            On entry, you'll find a <strong>welcoming hallway with a stylish boot room</strong>, offering practical storage for 
            shoes, coats, and outdoor gear.
          </p>

          <p>
            With its elevated views, natural light, and tranquil setting, Cairn is a warm and comfortable retreat 
            whether you're visiting for business or leisure.
          </p>



                <div id="hostaway-calendar-widget"></div>
                <p><strong>Can't find availability for the dates you're looking for? Try our sister apartments <Link to="/brora">Brora</Link> or <Link to="/kinloch">Kinloch</Link> at the same location!</strong></p>

          <div className="slider-wrapper">
            <SlidingGallery 
              images={images} 
              currentSlide={currentSlide} 
              onSlideChange={setCurrentSlide} 
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cairn;
